<template>
	<div class="main">
		<el-form :model="form" :rules="rules" ref="frmAdd" label-width="100px" class="demo-ruleForm">
			<el-form-item label="地址" prop="ip">
				<el-input v-model="form.ip"></el-input>
			</el-form-item>
			<el-form-item label="端口号" prop="host">
				<el-input v-model="form.host"></el-input>
			</el-form-item>
			<el-form-item label="平台名称" prop="name">
				<el-input v-model="form.name"></el-input>
			</el-form-item>
			<el-form-item label="所在地市" prop="areaName">
				<el-input v-model="form.areaName"></el-input>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {

				},
				rules: {
					id: [{
						required: true,
						message: '请输入序号',
						trigger: 'blur'
					}],
					ip: [{
						required: true,
						message: '请输入地址',
						trigger: 'blur'
					}],
					host: [{
						required: true,
						message: '请输入端口号',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '请填写平台名称',
						trigger: 'blur'
					}],
					areaName: [{
						required: true,
						message: '请填写所在地市',
						trigger: 'blur'
					}]
				}
			}
		},
		
	}
</script>

<style scoped>
	
</style>
